/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import * as styles from "./Gallery.module.css";
// import Img from "gatsby-image";
// import PinnacleData from "./PinnacleData";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";
import ImageModal from "./ImageModal";
import interiorImage1 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-01-Living-room.jpg";
import interiorImage2 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-02-Dinnig.jpg";
import interiorImage3 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-03-Kitchen.jpg";
import interiorImage4 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-04-Master-Bedroom.jpg";
import interiorImage5 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-05-Bathroom.jpg";
import interiorImage6 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-06-Bedroom-02.jpg";
import interiorImage7 from "../../../images/on-going-projects/enchanted/3BHK-INTERIORS/3BHK-07-Bedroom-02.jpg";
import interiorImage8 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-01-Living-Room.jpg";
import interiorImage9 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-02-Dining.jpg";
import interiorImage10 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-03-Kitchen.jpg";
import interiorImage11 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-04-Master-Bedroom.jpg";
import interiorImage12 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-05-Bathroom.jpg";
import interiorImage13 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-06-Bedroom-02.jpg";
import interiorImage14 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-07-Bedroom-03.jpg";
import interiorImage15 from "../../../images/on-going-projects/enchanted/4BHK-INTERIORS/4BHK-08-Bedroom-04.jpg";

import exteriorImage1 from "../../../images/on-going-projects/enchanted/EXTERIOR/1-Eye-level-Night-View.jpg";
import exteriorImage2 from "../../../images/on-going-projects/enchanted/EXTERIOR/2-Eye-level-Day-View.jpg";
import exteriorImage3 from "../../../images/on-going-projects/enchanted/EXTERIOR/3-NW-Corner-Part-Aerial-View.jpg"; 
import exteriorImage4 from "../../../images/on-going-projects/enchanted/EXTERIOR/4-Roof-view-with-landscape-podium.jpg";
import exteriorImage5 from "../../../images/on-going-projects/enchanted/EXTERIOR/5-Podium-Landscape-view-eye-level-1.jpg";
import exteriorImage6 from "../../../images/on-going-projects/enchanted/EXTERIOR/6-Podium-Landscape-view-eye-level-02.jpg";
import exteriorImage7 from "../../../images/on-going-projects/enchanted/EXTERIOR/7-Swimming-Pool-View-with-Decks.jpg";
import exteriorImage8 from "../../../images/on-going-projects/enchanted/EXTERIOR/8-Commercial-Shop-Front-view.jpeg";
import exteriorImage10 from "../../../images/on-going-projects/enchanted/EXTERIOR/10-Eye-level-Evening-View.jpg";
import exteriorImage11 from "../../../images/on-going-projects/enchanted/EXTERIOR/11-Early-Morning-View.jpg";
import exteriorImage12 from "../../../images/on-going-projects/enchanted/EXTERIOR/12-Mindscape-Garden.jpg";
import exteriorImage13 from "../../../images/on-going-projects/enchanted/EXTERIOR/13-Koi-Pound.jpeg";
import exteriorImage14 from "../../../images/on-going-projects/enchanted/EXTERIOR/14-Basketball-Court-View.jpeg";
import exteriorImage15 from "../../../images/on-going-projects/enchanted/EXTERIOR/17-Entry-Gate-View.jpeg";

import clubHouseImage1 from "../../../images/on-going-projects/enchanted/AMENITIES/Club-house-Lobby.jpg";
import clubHouseImage2 from "../../../images/on-going-projects/enchanted/Images/1-Multipurpose-Hall-Image.jpg";
import clubHouseImage3 from "../../../images/on-going-projects/enchanted/AMENITIES/13-Conference-Room.jpg";
import clubHouseImage4 from "../../../images/on-going-projects/enchanted/AMENITIES/5-Mini-Theatre.jpg";
import clubHouseImage5 from "../../../images/on-going-projects/enchanted/AMENITIES/4-Dining.jpg";
import clubHouseImage6 from "../../../images/on-going-projects/enchanted/AMENITIES/11-Creche.jpg";
import clubHouseImage7 from "../../../images/on-going-projects/enchanted/AMENITIES/8-Gym.jpg";
import clubHouseImage8 from "../../../images/on-going-projects/enchanted/AMENITIES/3-Indoor-Golf.jpg";
import clubHouseImage9 from "../../../images/on-going-projects/enchanted/AMENITIES/10-Indoor-Game-Arena.jpg";
import clubHouseImage10 from "../../../images/on-going-projects/enchanted/AMENITIES/9-Badminton-Court.jpg";
import clubHouseImage11 from "../../../images/on-going-projects/enchanted/AMENITIES/6-Yoga.jpg";
import clubHouseImage12 from "../../../images/on-going-projects/enchanted/AMENITIES/7-karoake.jpg";


function Gallery() {
  const [activeTab, setActiveTab] = useState("interior");
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  // const projectData = PinnacleData();

  // const interiorImages =
  //   projectData?.[0]?.sections?.[0]?.gallery?.[1]?.images?.map((item) => ({
  //     src: item,
  //     alt: "gallery image",
  //   }));

  // const exteriorImages =
  //   projectData?.[0]?.sections?.[0]?.gallery?.[0]?.images?.map((item) => ({
  //     src: item,
  //     alt: "gallery image",
  //   }));

  const interiorImages = [
    {
      src: interiorImage1,
      alt: "gallery image",
    },
    {
      src: interiorImage2,
      alt: "gallery image",
    },
    {
      src: interiorImage3,
      alt: "gallery image",
    },
    {
      src: interiorImage4,
      alt: "gallery image",
    },
    {
      src: interiorImage5,
      alt: "gallery image",
    },
    {
      src: interiorImage6,
      alt: "gallery image",
    },
    {
      src: interiorImage7,
      alt: "gallery image",
    },
    {
      src: interiorImage8,
      alt: "gallery image",
    },
    {
      src: interiorImage9,
      alt: "gallery image",
    },
    {
      src: interiorImage10,
      alt: "gallery image",
    },
    {
      src: interiorImage11,
      alt: "gallery image",
    },
    {
      src: interiorImage12,
      alt: "gallery image",
    },
    {
      src: interiorImage13,
      alt: "gallery image",
    },
    {
      src: interiorImage14,
      alt: "gallery image",
    },
    {
      src: interiorImage15,
      alt: "gallery image",
    },
  ];

  const exteriorImages = [
    {
      src: exteriorImage1,
      alt: "gallery image",
    },
    {
      src: exteriorImage2,
      alt: "gallery image",
    },
    {
      src: exteriorImage3,
      alt: "gallery image",
    },
    {
      src: exteriorImage4,
      alt: "gallery image",
    },
    {
      src: exteriorImage5,
      alt: "gallery image",
    },
    {
      src: exteriorImage6,
      alt: "gallery image",
    },
    {
      src: exteriorImage7,
      alt: "gallery image",
    },
    {
      src: exteriorImage8,
      alt: "gallery image",
    },
    // {
    //   src: exteriorImage9,
    //   alt: "gallery image",
    // },
    {
      src: exteriorImage10,
      alt: "gallery image",
    },
    {
      src: exteriorImage11,
      alt: "gallery image",
    },
    {
      src: exteriorImage12,
      alt: "gallery image",
    },
    {
      src: exteriorImage13,
      alt: "gallery image",
    },
    {
      src: exteriorImage14,
      alt: "gallery image",
    },
    {
      src: exteriorImage15,
      alt: "gallery image",
    },
  ];

  const clubHouseImages = [
    {
      src: clubHouseImage1,
      alt: "gallery image",
    },
    {
      src: clubHouseImage2,
      alt: "gallery image",
    },    
    {
      src: clubHouseImage3,
      alt: "gallery image",
    },
    {
      src: clubHouseImage4,
      alt: "gallery image",
    },
    {
      src: clubHouseImage5,
      alt: "gallery image",
    },
    {
      src: clubHouseImage6,
      alt: "gallery image",
    },
    {
      src: clubHouseImage7,
      alt: "gallery image",
    },
    {
      src: clubHouseImage8,
      alt: "gallery image",
    },
    {
      src: clubHouseImage9,
      alt: "gallery image",
    },
    {
      src: clubHouseImage10,
      alt: "gallery image",
    },
    {
      src: clubHouseImage11,
      alt: "gallery image",
    },
    {
      src: clubHouseImage12,
      alt: "gallery image",
    },
  ];

  return (
    <>
      <div className={styles.gallery} id="gallery">
        <div className={styles.galleryHeader}>
          <h1>
            <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
            Gallery
          </h1>
          <div className={styles.tabs}>
            <button
              className={`${styles.tab} ${
                activeTab === "interior" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("interior")}
            >
              Interior
            </button>
            <button
              className={`${styles.tab} ${
                activeTab === "exterior" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("exterior")}
            >
              Exterior
            </button>
            <button
              className={`${styles.tab} ${
                activeTab === "clubhouse" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("clubhouse")}
            >
              Club house
            </button>
          </div>
        </div>

        <div className={styles.galleryGrid}>
          {(activeTab === "interior"
            ? interiorImages
            : activeTab === "exterior"
            ? exteriorImages
            : clubHouseImages
          ).map((image, index) => (
            <div
              className={styles.galleryItem}
              key={index}
              onClick={() => {
                setSelectedGalleryImage(index + 1);
                setShowGalleryModal(true);
              }}
            >
              {/* <img loading="lazy" 
                  src={image.src}
                  alt={image.alt}
                  fluid={image.src.childImageSharp.fluid}
                /> */}
              <img loading="lazy"  src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>

      {showGalleryModal ? (
        <ImageModal
          imagesArray={
            activeTab === "interior" ? interiorImages : activeTab === "exterior" ? exteriorImages : clubHouseImages
          }
          selectedImage={selectedGalleryImage}
          setSelectedImage={setSelectedGalleryImage}
          showModal={showGalleryModal}
          setShowModal={setShowGalleryModal}
        />
      ) : null}
    </>
  );
}

export default Gallery;
